import getUrls from "../api";
import ASPCoreReportDataService from "./aspcore-report-data-service";

const prepareDataService = basepath => {
    const { baseUrl } = getUrls(basepath);
    const dataService = new ASPCoreReportDataService(baseUrl);
    return dataService;
};

export default prepareDataService;
